import { personListsApi } from "@/api/personListsApi";
import { safePrefetch } from "@/utils/prefetchUtils";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Custom hook for prefetching talent management data
 * Automatically prefetches data for talent-related pages
 */
export const useTalentPrefetch = (user) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const isInTalentSection = location.pathname.startsWith(
    "/employers/talent-search"
  );
  const shouldPrefetch = isInTalentSection && user?.employerId;

  // Prefetch person lists when in talent section using dispatch without subscription
  useEffect(() => {
    if (shouldPrefetch) {
      // Query parameters for prefetching - match the default state of TalentListsTable
      const personListsParams = {
        employerPermalink: user?.employerId,
        perPage: 50,
        cursor: null, // matches usePagination default
        searchQuery: "", // matches useSearch default (empty string, not null)
      };

      safePrefetch(dispatch, personListsApi.endpoints.getPersonLists.initiate, {
        ...personListsParams,
      });
    }
  }, [shouldPrefetch, dispatch, user?.employerId]);

  // Note: Not prefetching persons data as it requires specific parameters
  // (search, filters, etc.) that vary by page
};
